import type { VehicleWithDriverAndPeripheralsResponse } from '~/api/generated-api';
import { AssetReportType } from './asset.model';
import type { Entity, PartialEntity } from './common.model';
import type { Fleet } from './fleet.model';
import type { Organization } from './organization.model';

export const VEHICLE_LIST_SUPPORTED_TABS = [
  AssetReportType.FLEET_READINESS,
  AssetReportType.DIAGNOSTICS,
  AssetReportType.BATTERY,
  AssetReportType.RECALLS,
];

export enum OnStarUnitState {
  ENABLED = 'ENABLED',
  CONNECTED = 'CONNECTED',
  DISABLED = 'DISABLED',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  UNKNOWN = 'UNKNOWN',
  NOT_EQUIPPED = 'NOT_EQUIPPED',
}

/**
 * Vehicle assignment item type used in the "Change fleet" modal.
 * Extends common fields from the generated VehicleWithDriverAndPeripheralsResponse type.
 */
export type VehicleAssignmentItem = Entity &
  Pick<
    VehicleWithDriverAndPeripheralsResponse,
    | 'make'
    | 'model'
    | 'year'
    | 'assignedDevices'
    | 'imageSourceUrl'
    | 'assignedDriver'
    | 'fleetId'
  > & {
    organization?: PartialEntity<Organization>;
    fleet?: PartialEntity<Fleet>;
  };
